// extracted by mini-css-extract-plugin
export default {"cbx":"Checkbox_cbx__NWRRV","inp-cbx":"Checkbox_inp-cbx__mBH3r","wave":"Checkbox_wave__GcHas"};